import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidePage from "../pages/guide/page";
import CSSBuyGuidePage from "../pages/cssbuy/page";
import SuperbuyGuidePage from "../pages/superbuy/page";
import OopbuyGuidePage from "../pages/oopbuy/page";
import SafetyGuidePage from "../pages/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <GuidePage />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <CSSBuyGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuyGuidePage />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <OopbuyGuidePage />,
  },
  {
    path: "/shopping-safety-guide",
    element: <SafetyGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;